<template>
  <div class="min-vh">
    <CRow class="no-gutters px-3 px-sm-0">
      <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
        <h1 class="mr-sm-4 header-main text-uppercase">OVERVIEW</h1>
      </b-col>
    </CRow>
    <div>
      <chart></chart>
    </div>
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  components: {
    Chart
  },
};
</script>

<style></style>
